import React from "react";
import ImageOne from "./E_One";
import ImageTwo from "./E_two";
import ImageThree from "./E_three";
import Navbar from "./Navbar";
const Explore = () => {
  return (
    <div>
      <ImageOne />
      <Navbar />
      <ImageTwo />
      <ImageThree />
    </div>
  );
};

export default Explore;
